import type { SvgProps } from "../types";

export const DrinksSvg = ({
  width = "100px",
  height = width,
  color = "#000000",
}: SvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Drinks</title>
      <path
        d="M152.061 122.3C163.619 126.604 272.774 134.317 272.774 121.607C272.774 120.195 157.105 116.862 149.98 121.607C148.521 122.579 149.712 136.106 149.98 138.241C155.438 181.862 149.644 343.044 154.835 348.234C157.32 350.712 259.146 349.729 276.242 345.458C277.245 345.21 274.161 180.051 274.161 120.221"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M305.034 51C261.417 149.159 210.668 245.103 167.348 343.062"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M153.439 166.833C191.406 167.551 231.071 163.361 267.483 171.997"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M181.466 168.56C194.591 160.736 202.376 149.941 204.496 135.255C218.806 36.1253 68.1028 58.4107 99.2515 151.319C105.831 170.948 122.163 181.544 141.381 183.935"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M164.566 103.849C153.537 115.803 140.615 140.698 133.969 148.354"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="14"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M124.233 126.102C138.86 126.056 151.756 122.086 165.957 120.539"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="14"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M135.359 105.24C144.636 117.681 160.939 134.916 168.738 141.4"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="14"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M263.244 203.987C206.147 225.583 257.962 111.524 268.873 197.727"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="14"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M230.699 177.653C233.104 180.938 237.832 191.744 234.124 194.691C197.033 224.209 182.305 160.852 219.739 170.158C229.448 172.573 230.089 172.099 231.384 182.427"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="14"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M191.689 197.855C178.555 267.556 137.468 152.483 192.381 182.747"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="14"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M257.724 238.009C175.601 290.752 240.967 145.014 261.92 239.408"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="14"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
